import React from 'react';
import classnames from 'classnames';
import { kebabCase } from 'lodash';

const ColorSelector = ({color, code, inStock, isSelected, onClick}) => (
  <div className="color-selector">
    <button
      disabled={!inStock}
      onClick={onClick}
      className={classnames('color-selector__btn', {
        'color-selector__btn--is-selected': isSelected
      })}
    >
      {color}
      <span
        className='color-selector__blob'
        style={{backgroundColor: code}}
      />
    </button>
  </div>
);

export default ColorSelector;



// WEBPACK FOOTER //
// ./assets/scripts/components/ProductSelector/ColorSelector.js